/**
 * bootprompt.js locale configuration
 * locale : Thai
 * author : Ishmael๛
 */

import { addLocale } from "../bootprompt";

addLocale("th", {
  OK: "ตกลง",
  CANCEL: "ยกเลิก",
  CONFIRM: "ยืนยัน",
});
